import React from 'react';
import {usePlatformStyles} from 'hooks';
import {StyleSheet, Image, Platform, ImageStyle, Pressable} from 'react-native';
import {icons, IconType} from 'constants/icons';
/**
 * types
 */
type sizeType = 'sm' | 'md' | 'lg';

type styleType = {
  icon: ImageStyle;
};

export type IconPropType = Readonly<{
  type: IconType;
  sizeVaiant?: sizeType;
  style?: ImageStyle;
  size?: number;
  onPress?: () => void;
}>;

export function Icon(props: IconPropType) {
  const {type, sizeVaiant, size = null, onPress} = props;

  const webStyle = usePlatformStyles('web');
  let sizeStyle: ImageStyle = size
    ? {
        width: size,
        height: size,
      }
    : {};

  let iconSize: sizeType = 'sm';

  if (Platform.OS === 'web') {
    iconSize = 'md';
  }

  const iconElement = (
    <Image
      resizeMode="contain"
      source={icons[type][sizeVaiant ?? iconSize]}
      style={[webStyle(styles.icon), sizeStyle]}
    />
  );

  return onPress ? <Pressable onPress={onPress}>{iconElement}</Pressable> : iconElement;

}

const styles: styleType = StyleSheet.create({
  icon: {
    width: 20,
    height: 20,
  },
});
